// 背景分頁：BACKGROUND_INIT 由模型資料初始化（整個取代）；BACKGROUND_UPDATE 合併部分欄位
export const BACKGROUND_INIT = 'BACKGROUND_INIT';
export const BACKGROUND_UPDATE = 'BACKGROUND_UPDATE';
